module.exports = __webpack_public_path__ + "img/gs3.12ddfc84.png";